/* eslint-disable */
import { defineStore } from 'pinia';
import { useLegacyKioskStore as useKioskStore } from './kiosk-store';
import { useKioskStore as useNewKioskStore } from '@/stores/useKioskStore';
import { useOrderStore } from '@/stores/useOrderStore';
import axios from "axios";
import { useKioskRoute } from '@/composables/useKioskRoute';
import { useApi } from '@/composables/useApi';

let interval = null;
const API_URL = process.env.VUE_APP_API;

function debounce(func, delay) {
	let debounceTimer;
	return function () {
		const context = this
		const args = arguments
		clearTimeout(debounceTimer)
		debounceTimer = setTimeout(() => func.apply(context, args), delay)
	}
}

function parseResponse(response, posModel) {
	let final = null;
	const jsonModels = ['sunmi_p2', 'gptom'];

	try {
		if (jsonModels.includes(posModel)) {
			// JSON response
			final = result ? JSON.parse(response) : {};
		} else {
			if (response === '\x06') {
				// console.log("ACK");
				return null;
			} else if (response === '\x05') {
				// console.log("ENQ");
				return null;
			} else if (response === '\x15') {
				// console.log("NAK");
				final = {
					error: 'NAK'
				}
			} else if (response === '\x04') {
				// console.log("EOT");
			} else {
				let odp = []
				let word = []
				for (let i = 0; i < response.length; i++) {
					// console.log("Char: ", response[i]);
					if (response[i] === '\x1c' || response[i] === '\x03' || response[i] === '\x02' || response[i] === '\x5c') {
						odp.push(word)
						word = []
					} else {
						word.push(response[i])
					}
				}

				// console.log("Odpoved:", odp);
				// Parse odp
				final = {}
				for (let i = 0; i < odp.length; i++) {
					const element = odp[i]
					if (element.length > 0) {
						switch (posModel) {
							case "ux410":
							case "p400":
							case "in3000":
								final[element.shift()] = element.join("")
								break;
							case "paxa920":
								final[i] = element.join("")
								break;
							// final[element.shift()] = element.join("")
							// break;
							default:
								final[i] = element.join("")
								break;
						}
					}
				}
				console.log("Parsed: ", final);
			}
		}
	} catch (e) {
		console.log("parseResponse error: ", e);
	}
	return final
}


/**
 * Decodes a base-64 encoded string that contains Unicode characters.
 *
 * @param {string} str - The base-64 encoded string to be decoded
 * @return {string} The decoded Unicode string
 */
function b64DecodeUnicode(str) {
	return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
	}).join(''));

}

function parseCartForBackend(cart) {
	return cart.map(item => {
		return {
			productId: item.details.iid,
			quantity: item.amount,
			modifiers: (item.modifiers || []).map((mod) => {
				console.log('mod:', mod);

				return mod.iid
			}),
			annotation: (item.notes || []).map(note => note.name).join(',')
		};
	});
}

export const useBasketStore = defineStore('basket', {
	state: () => ({
		items: [],
		checkoutStatus: null,
		tempCart: [],
		qerko: {},
		alert: false,
		paymentStatus: null,
		septim: {},
		paymentType: null,
		paymentObject: null,
		toPay: 0,
		orderType: 'toTable',
		orderDateTime: null,
		statusDialog: false,
		paymentMethodStatus: {
			pos: true,
			cash: true,
			test: true,
			qerko: false
		},
		cashDialog: false,
		cardDialog: false,
		cancelDialog: false,
		alertDialog: {
			title: null,
			value: null,
			level: 'warning',
			button: false
		},
		alertCode: 0,
		mPos: {
			alert: false,
			sumTotal: 0,
			title: 'Alert',
			message: 'Payment kiosk is busy now. Please wait and try again later.',
			status: 'ok',
			titleBgColor: 'negative'
		},
		// Testy
		transactionTS: 0,
		statusObj: {},
		messageObj: {},
		statusTS: null,
		messageTS: null,
		cashierFlag: null,
		cashierModuleActive: false,
		overrideAlert: false,
	}),
	getters: {
		countCartPrice: (state) => {
			return state.tempCart.reduce((total, product) => {
				return total + product.total * product.quantity;
			}, 0);
		},
		getQuantity: (state) => {
			return (id) => {
				const cartItem = state.tempCart.find((item) => item.id === id);
				// console.log("Getter: ", cartItem, id);
				let a = 1;
				if (cartItem !== undefined) {
					a = cartItem.quantity;
				}
				return a;
			};
		},
		getExpanded: (state) => {
			return state.tempCart.map((item) => item.id);
		},
		countTotalPrice: (state) => {
			return state.items.reduce((total, product) => {
				return total + product.total * product.quantity;
			}, 0);
		},
		countTotalNetPrice: (state) => {
			return state.items.reduce((net, item) => {
				return net + item.price * item.quantity;
			}, 0);
		},
		countTotalTax: (state) => {
			return state.items.reduce((tax, item) => {
				return tax + item.tax * item.quantity;
			}, 0);
		},
		getAddedNames: (state) => {
			return state.tempCart.map((item) => item.name);
		},
		activeOrderId: (state) => {
			return state.paymentObject?.orderId;
		}
	},
	actions: {
		// DEPRECATED:
		qerkoOrder(order) {
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");
			// myHeaders.append("Cookie", "connect.sid=s%3APJs-LNVr1XnXIFoMbKw-nHS05OcvMo5O.ejVzvIg1Oa5IAishkZBzNlR0ZjJl8DMS2pfGd7l5RdM");

			// console.log("Order", order);
			//"idOrder": "20220325-002",
			// "bill": {
			// 				"id": "20220325-002",
			// 				"currency": "EUR",
			// 				"items": [{
			// 					"name": "Páv na víně",
			// 					"price": "100",
			// 					"quantity": "1"
			// 				}]
			// 			}

			// Parse order.items to Qerko format
			// TODO: currency z kiosk store!
			// TODO: Odchytavat errors
			const raw = JSON.stringify({
				"orderId": order.orderId,
				"currency": "EUR",
				"items": order.items
			});

			const requestOptions = {
				method: 'POST',
				headers: myHeaders,
				body: raw,
				redirect: 'follow'
			};

			fetch(`${ API_URL }/api/qerko/order`, requestOptions)
				.then(response => response.text())
				.then(result => {
					// Some Mutations
					// console.log("Action", JSON.parse(result));
					// Make Qerko QR code
					// commit('setQerko', JSON.parse(result))
					this.qerko = result ? JSON.parse(result) : {}
					// this.setQerko(JSON.parse(result))

				})
				.catch(error => console.log('Error:qerkoOrder', error));
		},
		getCurrentDateTimePlusOneHour() {
			const now = new Date();

			const year = now.getFullYear();
			const month = String(now.getMonth() + 1).padStart(2, '0'); // mesiace sú 0-indexované
			const day = String(now.getDate()).padStart(2, '0');

			const hours = String(now.getHours() + 1).padStart(2, '0');
			const minutes = String(now.getMinutes()).padStart(2, '0');

			return `${ year }-${ month }-${ day } ${ hours }:${ minutes }`;
		},
		septimOrder(order, payment, orderTime) {

			// Logika: order -> request -> status
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");

			order.payment = payment;
			order.order.paymentMethod = payment;
			//order.order.orderDateTime = this.getCurrentDateTimePlusOneHour();
			order.order.orderTime = orderTime;
			// order.accountDetails = useKioskStore().SEPTIM.ACCOUNT
			// order.lang = useKioskStore().SEPTIM.LANG
			order.token = useKioskStore().SEPTIM.TOKEN;
			order.order.orderType = this.orderType;
			order.sept = {
				url: useKioskStore().SEPTIM.URL,
				webcare: useKioskStore().SEPTIM.WEBCARE,
				version: "1.0" // useKioskStore().SEPTIM.WEBCARE
			};
			delete order.tip;
			delete order.order.tip;
			// useKioskStore().SEPTIM.AUTH

			//console.log("Posielam ", useKioskStore().SEPTIM);


			console.log("Posielam ", order);

			const requestOptions = {
				method: 'POST',
				headers: myHeaders,
				body: JSON.stringify(order),
				redirect: 'follow'
			};
			//console.log("setOrder02", requestOptions)
			fetch(`${ API_URL }/api/septim/v2/createOrder`, requestOptions)
				.then(response => response.text())
				.then(result => {
					console.log("setOrder", JSON.parse(result))
					this.checkoutStatus = result ? JSON.parse(result) : {}
				})
				.catch(error => {
					// console.log('error', error)
					this.setOrder({
						error: {
							code: 400,
							message: 'Some error',
							rawMessage: error
						}
					})
				});
		},
		septimOrderPaymentRequest(order) {
			const kiosk = useKioskStore()
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");

			const { id, status, toBePaid } = order;


			const req = JSON.stringify({
				"aid": kiosk.aid,
				"bid": kiosk.bid,
				"orderId": id,
				"toBePaid": toBePaid,
				"status": 2
			});
			console.log('REQS send', req);

			const requestOptions = {
				method: 'POST',
				headers: myHeaders,
				body: req,
				redirect: 'follow'
			};
			// /order/payment/request
			fetch(`${ API_URL }/api/septim/v2/processpayment`, requestOptions)
				.then(response => response.text())
				.then(result => {
					//alert("Response Request Payment", result);
					console.log("2Response Request Payment", JSON.parse(result))
					// this.septimOrderPayment(result ? JSON.parse(result) : {})
				})
				.catch(error => {
					console.log('Error:septimOrderPaymentRequest', error)
				});
		},
		septimOrderPaymentRequestFailed(order) {
			console.log('run septimOrderPaymentRequestFailed');
			const kiosk = useKioskStore()
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");

			const { id, status, toBePaid } = order;

			const req = JSON.stringify({
				"aid": kiosk.aid,
				"bid": kiosk.bid,
				"orderId": id,
				"toBePaid": toBePaid,
				"status": 3
			});
			console.log('REQS send', req);

			const requestOptions = {
				method: 'POST',
				headers: myHeaders,
				body: req,
				redirect: 'follow'
			};
			// /order/payment/request
			fetch(`${ API_URL }/api/septim/v2/processpayment`, requestOptions)
				.then(response => response.text())
				.then(result => {
					//alert("Response Request Payment", result);
					console.log("2Response Request Payment", JSON.parse(result))
					// this.septimOrderPayment(result ? JSON.parse(result) : {})
				})
				.catch(error => {
					console.log('Error:septimOrderPaymentRequest', error)
				});
		},
		septimOrderPayment(order) {
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");

			order.lang = useKioskStore().SEPTIM.LANG
			order.token = useKioskStore().SEPTIM.TOKEN
			order.auth = useKioskStore().SEPTIM.AUTH

			const requestOptions = {
				method: 'POST',
				headers: myHeaders,
				body: JSON.stringify(order),
				redirect: 'follow'
			};

			fetch(`${ API_URL }/api/septim/payment`, requestOptions)
				.then(response => response.text())
				.then(result => {
					console.log("Response Payment", result);

				})
				.catch(error => {
					console.log('Error:septimOrderPayment', error)
				});
		},
		addToTempCart(item) {
			const element = item.element;
			// console.log("Element: ", element);
			let ingreds = [];
			if (element.ingredients !== undefined) {
				ingreds = element.ingredients;
			}
			const el = {
				id: element.id,
				iid: element.iid,
				name: element.name,
				price: element.price,
				quantity: 1,
				ingredients: ingreds,
				image: element.image,
				vat: element.vat,
				tax: element.tax,
				total: element.total,
				additional: element.additional,
				inMenuPrice: element.inMenuPrice,
				modifier: element.modifier,
				modifiers: [],
				specialPrice: element.specialPrice,
				recommended: element.recommended,
				package: element.package,
				productType: element.productType
			};
			this.tempCart.push(el);
			// console.log("Added to temp", this.tempCart);

		},
		updateIngredientsCart(item) {
			// console.log("Mutation Update", item.ingredients, this.ingredients);
			const id = item.id;
			const arr = this.tempCart;

			for (let i = 0; i < arr.length; i++) {
				const elm = arr[i];
				if (elm.id === id) {
					this.tempCart[i].ingredients = item.ingredients;
				}
			}
		},
		updateQuantityCart(item) {
			// console.log("Mutation Update", item);
			const id = item.id;
			const arr = this.tempCart;

			for (let i = 0; i < arr.length; i++) {
				const elm = arr[i];
				if (elm.id === id) {
					this.tempCart[i].quantity = item.quantity;
				}
			}
		},
		addItemQuantity(id) {
			// console.log("Incremetn", id);
			const cartItem = this.tempCart.find((item) => item.id === id);
			cartItem.quantity++;
			// console.log("addItemQnt", this.tempCart);

		},
		removeItemQuantity(id) {
			// console.log("Incremetn", id);
			const cartItem = this.tempCart.find((item) => item.id === id);
			cartItem.quantity--;
			if (cartItem.quantity < 1) {
				// cartItem.quantity = 1;
				const tempArr = [...this.tempCart]
				const filtered = tempArr.filter((item) => item.id !== id);
				this.tempCart = [...filtered];
				// console.log(this.tempCart);
			}
		},
		removeQuantity(id) {
			// console.log("Incremetn", id);
			const cartItem = this.tempCart.find((item) => item.id === id);
			cartItem.quantity--;
			if (cartItem.quantity < 1) {
				cartItem.quantity = 1;
				// const tempArr = [...this.tempCart]
				// const filtered = tempArr.filter((item) => item.id !== id);
				// this.tempCart = [...filtered];
				// console.log(this.tempCart);
			}
		},
		itemQuantity(id) {
			// console.log("Incremetn", id);
			const cartItem = this.tempCart.find((item) => item.id === id);
			return cartItem.quantity;
		},
		removeFromTempCart(id) {
			const index = this.tempCart.findIndex((i) => i.id === id);
			console.log("REmove", id, index);
			// console.log("R", this.tempCart);

			if (index > -1) {
				this.tempCart.splice(index, 1);
			}

			// this.tempCart = this.tempCart.filter(item => item.id !== id);

		},
		emptyTempCart() {
			this.tempCart = [];
		},
		emptyCart() {
			this.items = [];
		},
		addToBasket() {
			console.log("Add to Basket");
			this.items = [...this.items, ...this.tempCart];

			if (this.orderType === 'toTakeAway') {
				console.log("Pridam obal", this.tempCart);
				const obal = this.tempCart[0];
				if (obal.package?.id) {
					// Vyrobim item obal
					console.log("Vyrobim item obal");
					// Vyrobim item obal
					const el = {
						id: parseInt(`9999${ String(obal.package.id).padStart(4, '0') }`),
						iid: obal.package.id,
						name: obal.package.name,
						price: obal.package.price,
						quantity: obal.quantity,
						ingredients: [],
						image: "",
						vat: 0,
						tax: 0,
						total: obal.package.price,
						additional: [],
						inMenuPrice: 0,
						modifier: [],
						modifiers: [],
						specialPrice: 0,
						recommended: [],
						package: {},
						parentId: this.tempCart[0].id
					};
					this.items = [...this.items, ...[el]];
				}
			}

			this.tempCart = [];
		},
		directAddToBasket(product) {
			console.log("Direct Add to Basket");

			product[0].modifier = [];
			product[0].modifiers = [];
			product[0].ingredients = [];

			this.items = [...this.items, ...product];

			if (this.orderType === 'toTakeAway') {
				console.log("Pridam obal", product);
				const obal = product[0];
				if (obal.package?.id) {
					// Vyrobim item obal
					console.log("Vyrobim item obal");
					// Vyrobim item obal
					const el = {
						id: parseInt(`9999${ String(obal.package.id).padStart(4, '0') }`),
						iid: obal.package.id,
						name: obal.package.name,
						price: obal.package.price,
						quantity: obal.quantity,
						ingredients: [],
						image: "",
						vat: 0,
						tax: 0,
						total: obal.package.price,
						additional: [],
						inMenuPrice: 0,
						modifier: [],
						modifiers: [],
						specialPrice: 0,
						recommended: [],
						package: {},
						parentId: product[0].id
					};
					this.items = [...this.items, ...[el]];
				}
			}
		},
		removeFromBasket(id) {
			const index = this.items.findIndex((i) => i.id === id);
			if (this.orderType === 'toTakeAway') {
				const cartItem = this.items.find((item) => item.id === id);
				const packageId = cartItem.package.id;
				const packageIndex = this.items.findIndex((i) => i.iid === packageId);
				if (packageIndex > -1) {
					this.items.splice(packageIndex, 1);
				}
			}
			if (index > -1) {
				this.items.splice(index, 1);
			}
		},
		updateQuantity(id, count) {
			const cartItem = this.items.find((item) => item.id === id);
			cartItem.quantity = count;
			// TODO:
			// Ak ma obaly tak zmenim ich quantity -> vsetky items s parentId
			this.items.map((item) => {
				if (item.parentId === id) {
					item.quantity = count
				}
				return item;
			})
		},
		setDefaultBasketValues() {
			const kiosk = useKioskStore();
			this.tempCart = [];
			this.items = [];
			this.checkoutStatus = null;
			this.toPay = 0;
			kiosk.$patch({ processState: "intro" })
		},
		// setQerko(item) {
		// 	// console.log("QQ",item);
		// 	this.qerko = item
		// },
		setOrder(item) {
			// console.log("QQ",item);
			this.checkoutStatus = item
			// Zapisat do DB vysledok
			// updateOrder

		},
		// DEPRECATED:
		startPayment(pay) {
			// Platba cez POS !!!
			const kiosk = useKioskStore()

			const uid = {
				uid: kiosk.uid
			}
			// Volat lokalny mikro server a dopytovat platbu, musi byt Promise!!!
			// V test mode volame normalne API
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");
			const raw = JSON.stringify({
				...pay,
				...uid
			});

			const requestOptions = {
				method: 'POST',
				headers: myHeaders,
				body: raw,
				redirect: 'follow'
			};

			console.log("POS Payment", uid, pay);

			fetch(`${ process.env.CONTROLLER_URL }/api/pos/sale`, requestOptions)
				.then((response) => response.text())
				.then((result) => {
					const res = result ? JSON.parse(result) : {};
					console.log("Sale", res);
					this.paymentStatus = {
						...res,
						lastId: pay.id
					}

				})
				.catch((error) => {
					console.error({
						error
					})
				})
		},

		sanitizeAndRecalculate(obj) {
			const VAT_RATE = 0.21;

			function process(value) {
				if (Array.isArray(value)) {
					return value.map(process);
				} else if (value !== null && typeof value === 'object') {
					const result = {};
					for (const key in value) {
						let val = value[key];
						if (val === null || val === 'null') {
							val = 0;
						} else {
							val = process(val);
						}
						result[key] = val;
					}

					// If key is `total`, need to recalculate `net`, `vat`, `tax`
					if ('total' in result) {
						const total = typeof result.total === 'number' ? result.total : parseFloat(result.total) || 0;
						if (total > 0) {
							const net = total / (1 + VAT_RATE);
							const vat = total - net;
							result.total = parseFloat(total.toFixed(2));
							result.net = parseFloat(net.toFixed(2));
							result.vat = parseFloat(vat.toFixed(2));
							result.tax = parseFloat(vat.toFixed(2));
						} else {
							result.total = 0;
							result.net = 0;
							result.vat = 0;
							result.tax = 0;
						}
					}

					return result;
				} else {
					// Primitive
					return value === 'null' ? 0 : value;
				}
			}

			return process(obj);
		},

		// Insert new order
		insertNewOrder(order) {
			const orderStore = useOrderStore();
			const { cart, total, tipsAmount } = orderStore;

			return new Promise((resolve, reject) => {

				const kiosk = useKioskStore();
				const myHeaders = new Headers();
				myHeaders.append("Content-Type", "application/json");

				// console.log(kiosk.aid, kiosk.bid, order);

				const raw = JSON.stringify({
					aid: kiosk.aid,
					bid: kiosk.bid,
					kid: kiosk.kid,
					orderId: order.orderId,
					orderDetail: order.orderDetail,
					net: order.net,
					vat: order.vat,
					total: order.total,
					tip: tipsAmount,
					currency: kiosk?.currencyObject?.code || 'EUR',
					status: 8
				});

				const requestOptions = {
					method: 'POST',
					headers: myHeaders,
					body: raw,
					redirect: 'follow'
				};

				fetch(`${ API_URL }/api/neworder`, requestOptions)
					.then((response) => response.text())
					.then((result) => {
						// console.log("New Order", JSON.parse(result));
						const pay = result ? JSON.parse(result) : {};
						this.paymentObject = {
							...pay,
							// aid: kiosk.aid,
							// kid: kiosk.kid,
							items: this.sanitizeAndRecalculate(order.orderDetail),
							// orderDetail: order.orderDetail, // parse
							net: order.net,
							vat: order.vat,
							currency: kiosk?.currencyObject?.code || 'EUR',
							sumTotal: order.total + tipsAmount,
							sumToPay: order.total + tipsAmount,
							sumPaid: 0
						}

						this.paymentStatus = {
							lastId: pay.id
						}

						console.log("New Order: paymentObject", this.paymentObject);
						console.log("New Order: paymentStatus", this.paymentStatus);

						// TU volat SEPTIM A cakat na odpoved, ak je ok, platba ak nie tak Error screen => toto parsuje watcher
						// Posle objednavku do systemu (Septim)
						if (useKioskStore().SEPTIM.ACTIVE === "true") {
							const OUTLET_ID = useKioskStore().SEPTIM.OUTLET_ID;

							const orderCC = {
								order: {
									outletId: parseInt(OUTLET_ID),
									orderItems: parseCartForBackend(cart),
									calculatedPrice: total,
									tip: tipsAmount,
									tableId: 1,
								}
							}

							if (this.paymentObject?.oid) {
								orderCC.oid = this.paymentObject.oid;
							}

							console.log("Posiela do Septim (fn: septimOrderPaymentRequest): ", orderCC, this.septim.orderTime);
							this.septimOrder(orderCC, 'creditcard', this.septim.orderTime);
						}

						if (this.paymentType === "test") {
							// console.log("Test", JSON.parse(result));

							// this.paymentEmulation = false
							const order = result ? JSON.parse(result) : {};
							const oid = order?.oid

							this.alertDialog.value = `Thank you. Your order was processed. Your order number is ${ oid }`
							// 	title: t('payDialogPayCash'),
							// value: t('payDialogAccept') + ' ' + t('payDialogOrderNum', {n: paymentObject.value.oid}),
							// 	level: 'primary',
							// 	button: false,
							// }

							this.updateOrderStatus(1, "test")

							// this.printReceipt(oid, order)


						} else if (this.paymentType === "cash") {
							// Cash
							// const pay = JSON.parse(result)
							// this.paymentObject = {
							// 	...pay,
							// 	// aid: kiosk.aid,
							// 	// kid: kiosk.kid,
							// 	items: this.parseItems(order.orderDetail),
							// 	// orderDetail: order.orderDetail, // parse
							// 	net: order.net,
							// 	vat: order.vat,
							// 	currency: kiosk.currencyObject.code
							// }
							this.updateOrderStatus(8, "cash");

						} else {
							this.updateOrderStatus(8, "card");
							// this.startPayment(JSON.parse(result)) - controller

							const start = {
								type: "start",
								response: { ...this.paymentObject, ...{ paymentType: "CARD" } }
							}

							// this.startTransaction(start);
							this.salePos(pay);
						}

						resolve(this.paymentObject)

					})
					.catch((error) => {
						console.log("Error:insertNewOrder", error)
						// Chybovy Alert pre klienta !!!
						kiosk.callAlert({
							message: "Creating New Order error!!!"
						})

						reject(error);
					});

			});

		},
		updateOrderStatus(status, resp, id = null) {
			const kiosk = useKioskStore();
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");
			/*
			if(id === null || id === undefined) {
				if(this.paymentStatus?.lastId === undefined) {
					console.log("updateOrderStatus: missing last orderId");
					return {error: "updateOrderStatus: missing last orderId"}
				} else {
					id = this.paymentStatus.lastId
				}
			} */
			const raw = JSON.stringify({
				id: this.paymentObject.id,
				orderDetails: {
					status: status,
					response: resp
				}
			});

			const requestOptions = {
				method: 'POST',
				headers: myHeaders,
				body: raw,
				redirect: 'follow'
			};

			fetch(`${ API_URL }/api/updateorder`, requestOptions)
				.then((response) => response.text())
				.then((result) => {
					// console.log("Update", JSON.parse(result));
					return result ? JSON.parse(result) : {}

				})
				.catch((error) => {
					console.log("Error:updateOrderStatus", error)
					// Chybovy Alert pre klienta !!!
					kiosk.callAlert({
						message: "Update Order error!!!"
					})
				});

		},
		updateOrder(resp) {
			if (this.paymentStatus?.lastId === undefined) {
				console.error("updateOrder: Missing lastId");
				return { error: "updateOrder: Missing lastId" }
			}

			const kiosk = useKioskStore()

			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");
			const raw = JSON.stringify({
				id: this.paymentStatus.lastId,
				orderDetails: resp
			});

			const requestOptions = {
				method: 'POST',
				headers: myHeaders,
				body: raw,
				redirect: 'follow'
			};

			fetch(`${ API_URL }/api/updateorder`, requestOptions)
				.then((response) => response.text())
				.then((result) => {
					// console.log("Update", JSON.parse(result));
					return result ? JSON.parse(result) : {}

				})
				.catch((error) => {
					console.log("Error:updateOrder", error)
					// Chybovy Alert pre klienta !!!
					kiosk.callAlert({
						message: "Update Order error!!!"
					})
				});

		},
		// DEPRECATED:
		posOpen() {
			console.log("Open Connection");
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");

			const kiosk = useKioskStore().kiosk;

			// getParameter
			const posPort = kiosk.posPort;
			const posUrl = kiosk.posUrl;

			const raw = JSON.stringify({
				posPort: posPort,
				posUrl: posUrl
			});

			const requestOptions = {
				method: "POST",
				headers: myHeaders,
				body: raw,
				redirect: "follow",
			};

			fetch(`${ process.env.CONTROLLER_URL }/api/pos/open`, requestOptions)
				.then((response) => response.text())
				.then((result) => {
					const resp = result ? JSON.parse(result) : {}
					if (resp.status === 'connected') {
						console.log("Connected!", resp.message);
						this.paymentMethodStatus.pos = true
						this.alert = false

					} else if (resp.status === 'error') {
						// Error opakuj connect, hlaska?
						this.alertCode = 400;
						this.showAlert(400);
						this.paymentMethodStatus.pos = false
						// this.posOpen() Debounce this Fn
						// debounce(this.posOpen(), 5500);

					} else {
						/// Ina chyba
						console.log("POS error 3");
						// this.alert = true
						// this.alertDialog = {
						// 	title: this.t('errorTitle400'),
						// 	value: this.t('errorValue400'),
						// 	level: 'negative',
						// 	button: true
						// }
						// this.paymentMethodStatus.pos = false
					}
				})
				.catch((error) => {
					console.error({
						error
					})
				})
		},
		// DEPRECATED:
		posClose() {
			console.log("POS Close Connection!");
			const myHeaders = new Headers();

			const requestOptions = {
				method: "GET",
				headers: myHeaders,
				redirect: "follow",
			};
			fetch(`${ process.env.CONTROLLER_URL }/api/pos/close`, requestOptions)
				.then((response) => response.text())
				.then((result) => {
					const resp = result ? JSON.parse(result) : {};
					if (resp.status === 'disconnected') {
						console.log("POS Disconnected!");
					} else {
						console.log("POS Disconnection error!");
					}
				})
				.catch((error) => {
					console.error({
						error
					})
				})
		},
		printReceipt(oid, order) {
			// console.log("Print", order);
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");
			const raw = JSON.stringify({
				oid: oid,
				...order
			});

			// console.log("Print raw", raw);
			const requestOptions = {
				method: "POST",
				headers: myHeaders,
				body: raw,
				redirect: "follow",
			};

			fetch(`${ process.env.CONTROLLER_URL }/api/pos/print`, requestOptions)
				.then((response) => response.text())
				.then((result) => {
					console.log("Printed!");
				})
				.catch((error) => {
					console.error({
						error
					})
				})
		},
		cancelPayment(cancel) {
			// TODO: Rusi poslednu transakciu, nepouzivame
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");
			const raw = JSON.stringify({
				cancel
			});

			const requestOptions = {
				method: 'POST',
				headers: myHeaders,
				body: raw,
				redirect: 'follow'
			};

			fetch(`${ process.env.CONTROLLER_URL }/api/pos/cancel`, requestOptions)
				.then((response) => response.text())
				.then((result) => {
					const res = result ? JSON.parse(result) : {};
					console.log("Cancel", res);
				})
				.catch((error) => {
					console.error({
						error
					})
				})
		},
		refundPayment(refund) {
			// TODO:
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");
			const raw = JSON.stringify({
				refund
			});

			const requestOptions = {
				method: 'POST',
				headers: myHeaders,
				body: raw,
				redirect: 'follow'
			};

			fetch(`${ process.env.CONTROLLER_URL }/api/pos/cancel`, requestOptions)
				.then((response) => response.text())
				.then((result) => {
					const res = result ? JSON.parse(result) : {};
					console.log("Cancel", res);
				})
				.catch((error) => {
					console.error({
						error
					})
				})
		},
		septimOrderDates() {
			if (useKioskStore().SEPTIM.ACTIVE == "true") {
				// Check if Septim is Active
				const myHeaders = new Headers();
				myHeaders.append("Content-Type", "application/json");

				const order = {
					outletId: useKioskStore().SEPTIM.OUTLET_ID,
					token: useKioskStore().SEPTIM.TOKEN,
					lang: useKioskStore().SEPTIM.LANG
				}

				const requestOptions = {
					method: 'POST',
					headers: myHeaders,
					body: JSON.stringify(order),
					redirect: 'follow'
				};

				fetch(`${ API_URL }/api/septim/orderdates`, requestOptions)
					.then(response => response.text())
					.then(result => {
						this.septim = result ? JSON.parse(result) : {};
					})
					.catch(error => console.log('Error:septimOrderDates', error));
			}
		},
		// emulatePayment(order) {
		// 	// Write to DB
		// 	this.insertNewOrder(order)
		// },
		parseItems(items) {
			console.log("parseItems", items);
			let print = []

			items.forEach(element => {
				console.log(element);

				const qty = element.quantity;
				let obj = {
					name: element.name,
					price: element.price,
					quantity: qty,
					vat: element.vat,
					tax: element.tax,
					total: element.total
				}
				print.push(obj)
				if (element.ingredients.length > 0) {
					const ing = element.ingredients.map((el) => {
						let iii = {
							name: el.name,
							price: el.price,
							quantity: qty,
							vat: el.vat,
							tax: el.tax,
							total: el.total
						}
						return iii;
					});

					// print.push(ing)
					print = [...print, ...ing]
				}

			});

			console.log("Print", print);


			return print
		},
		startTransaction(start) {
			const { kioskId } = useNewKioskStore();

			// POST start
			console.log("Start", start);
			const config = {
				headers: {
					'BSS-SENDER-ID': 'kiosk',
					'BSS-KIOSK-ID': kioskId,
					'Content-Type': 'application/json'
				}
			};

			axios.post(`${ API_URL }/api/transaction/cashier`, start, config)
				.then((response) => {
					console.log("Start Transaction", response.data);
					this.cashierFlag = "start"
					const log = {
						type: 'log',
						payload: {
							orderId: this.activeOrderId,
							timestamp: Date.now(),
							start: start
						}
					}
					this.writeLog(log);
					// const res = response.data
				})
				.catch((error) => {
					console.log("Error:startTransaction", error)
					this.alertDialog = {
						title: 'Start Transaction Error',
						value: error,
						level: 'negative',
						button: true
					}
					this.alert = true;
				})

			// TEST
			// Sunmi
			// const response = "eyJyZXN1bHQiOiJTdWNjZXNzIiwiZXJyb3JDb25kaXRpb24iOiIiLCJjYXJkTnVtYmVyIjoiNDcjIy0jIyMjLSMjIyMtNDg3MyIsImFpZCI6IkEwMDAwMDAwMDMxMDEwIiwic2VxdWVuY2VOdW1iZXIiOiIxMjM0NTY3ODkwIiwiYnJhbmQiOiJWSVNBIiwibWV0aG9kIjoiQ0xFU1MiLCJhdXRob3JpemF0aW9uQ29kZSI6IjEyMzQ1NiIsInRlcm1pbmFsSWQiOiJWM01JWFRFU1QifQ==";
			// console.log(`TEST Parsed:`, parseResponse(decodedData, 'sunmi_p2'));
			// Ingenico
			// const response = "AkIwMDE0NTY3NDIgIDI0MDkxOTE4Mjk1NDAwMDAwMjJGOUNGNxxUMDAcUjAwMBxQNDc5NjA4KioqKioqNDg3MxxGODMxMzgyICAcSlZJU0EcRTEyMjQcYUEwMDAwMDAwMDMxMDEwHGZJU09fODg1OS0yHG4yNDA5MTkxODMwMjEcdDE5LzA5LzI0ICAxODozMDoyMSAgMDAwMQpE77+9VktBOjAwOSAgIO+/ve+/vVRFTktBOjAwMDEKSUQuWkHvv73vv71aRU7vv706IDQ1Njc0MiAgICAgCiR7U0VQQVJ9CkEwMDAwMDAwMDMxMDEwICAgICAgICAgIApWSVNBIGNvbnRhY3RsZXNzICAgIChDTCkKICAgICAqKioqICoqKiogKioqKiA0ODczCiAgICAgICAgIFBST0RFSiAgICAgICAgIArvv73vv71zdGthIEVVUjogICAgICAgICA1LDUwClNla3Zlbu+/vS7vv73vv71zbG86IDAwMTAwOTAwMQpBdXRvcml6Ye+/vW7vv70ga++/vWQ6ICA4MzEzODIKMDEgMTAgMDAgMDAgMDEgMDAgMDggMDAgMDAgMDAgMDAgMDAgICAgICAgICAgICAgCiR7U0VQQVJ9CiAgICAgICBQbGF0YmEgamUgICAgICAgIAogICAgdmUgdnlicmFu77+9IG3vv71u77+9ICAgICAKLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tCiAgRG9rbGFkIHVjaG92ZWp0ZSBwcm8gIAogICBwb3pk77+9au+/ve+/vSBrb250cm9sdSAgICAKJHtQQUdFfQocQjU1MBxpMDAxMDA5MDAxAw==";
			// const decodedData = b64DecodeUnicode(response);
			// console.log(`TEST Decoded:`, decodedData);
			// console.log(`TEST Parsed:`, parseResponse(decodedData, 'in3000'));
			// TEST END

		},
		cancelTransaction(cancel) {
			const { kioskId } = useNewKioskStore();

			const config = {
				headers: {
					'BSS-SENDER-ID': 'kiosk',
					'BSS-KIOSK-ID': kioskId,
					'Content-Type': 'application/json'
				}
			};

			axios.post(`${ API_URL }/api/transaction/cashier`, cancel, config)
				.then((response) => {
					console.log("Cancel Transaction", response.data);
					this.cashierFlag = "cancel"
					const log = {
						type: 'log',
						payload: {
							orderId: this.activeOrderId,
							timestamp: Date.now(),
							cancel: cancel
						}
					}
					this.writeLog(log);

				})
				.catch((error) => {
					console.log("Error:cancelTransaction", error)
					this.alertDialog = {
						title: 'Start Transaction Cancel',
						value: error,
						level: 'negative',
						button: false
					}
				})
		},
		printTransaction(print) {
			const { kioskId } = useNewKioskStore();

			return new Promise((resolve, reject) => {
				const config = {
					headers: {
						'BSS-SENDER-ID': 'kiosk',
						'BSS-KIOSK-ID': kioskId,
						'Content-Type': 'application/json'
					}
				};

				axios.post(`${ API_URL }/api/transaction/cashier`, print, config)
					.then((response) => {
						console.log("printTransaction", response.data);
						this.cashierFlag = "print"
						const log = {
							type: 'log',
							payload: {
								orderId: this.activeOrderId,
								timestamp: Date.now(),
								print: print
							}
						}
						this.writeLog(log);

						resolve(response)
					})
					.catch((error) => {
						console.log("Error:printTransaction", error)
						this.alertDialog = {
							title: 'Start Transaction Print',
							value: error,
							level: 'negative',
							button: true
						}
						reject(error)
					})
			})
		},
		// DEPRECATED:
		finishTransaction() {
			const kiosk = useKioskStore();

			console.log("PAY Obj: ", this.paymentObject);
			const resetObj = {
				oid: null,
				orderId: "",
				currency: kiosk?.currencyObject?.code || 'EUR',
				total: 0,
				id: null,
				items: [],
				net: 0,
				vat: 0,
				sumTotal: 0,
				sumToPay: 0,
				sumPaid: 0
			}

			const fin = {
				type: "finished",
				response: resetObj
			}

			const { kioskId } = useNewKioskStore();

			const config = {
				headers: {
					'BSS-SENDER-ID': 'kiosk',
					'BSS-KIOSK-ID': kioskId,
					'Content-Type': 'application/json'
				}
			};

			axios.post(`${ API_URL }/api/transaction/cashier`, fin, config)
				.then((response) => {
					console.log("finishTransaction", response.data);
					this.cashierFlag = "finished"

				})
				.catch((error) => {
					console.log("Error:finishTransaction", error)
					this.alertDialog = {
						title: 'Start Transaction Finished',
						value: error,
						level: 'negative',
						button: true
					}
				})
		},
		getKioskStatus() {
			const { request } = useApi();
			const { makePath } = useKioskRoute();
			const { kioskId } = useNewKioskStore();
			const config = {
				headers: {
					'BSS-SENDER-ID': 'kiosk',
					'BSS-KIOSK-ID': kioskId
				}
			};
			//const ts = Date.now();
			// console.log(`Get kiosk status ${ts}`);
			// axios.get(`${API_URL}/api/transaction/kiosk?${ts}`, config)

			// const dateNow = Date.now();

			axios.all([
				axios.get(`${ API_URL }/api/transaction/status?${ Date.now() }`, config),
				axios.get(`${ API_URL }/api/transaction/message?${ Date.now() }`, config)
			])
				.then(axios.spread((status, messageResp) => {
					const statusObj = status.data;
					// console.log('basket-store.js, getKioskStatus(), status: ', status);
					useKioskStore().kioskStatus = statusObj;

					const paymentOptions = useKioskStore().paymentOptions;
					const payload = statusObj?.payload
					const isEnoughPaper = payload?.printer1 !== 'PAPER_EMPTY' && payload?.printer2 !== 'PAPER_EMPTY';

					if (!isEnoughPaper) {
						request(`/api/${ kioskId }/mqtt/paperout`);
						return;
					}

					const paper1 = payload?.printer1 == "PAPER_ENOUGH" || payload?.printer1 == "PAPER_LOW" || paymentOptions.includes('noprint') ? false : true;
					const paper2 = payload?.printer2 == "PAPER_ENOUGH" || payload?.printer2 == "PAPER_LOW" || paymentOptions.includes('noprint') ? false : true;

					this.cashierModuleActive = payload?.isPaymentModuleActive;

					if (statusObj === undefined || JSON.stringify(statusObj) === '{`}') {
						this.alertCode = 300
						this.showAlert(300);
					} else if (paper1 && paper2) {
						this.alertCode = 100
						this.showAlert(100);
					} else if (!payload?.checkPayment) {
						this.alertCode = 200
						if (!this.overrideAlert) {
							this.showAlert(200);
						}
						this.paymentMethodStatus.cash = false
						this.cashDialog = false
						this.overrideAlert = true
					} else {
						// TODO: Po prvom spusteni nepremaze hlasku o chybe!!!
						if (this.alertCode < 400) {
							this.alertCode = 0
							this.showAlert(0);
						}

					}

					const messageObj = messageResp.data;

					// Check Transactions
					if (messageObj !== undefined || JSON.stringify(messageObj) !== '{}') {
						const message = messageObj?.payload
						const timestamp = messageObj?.timestamp
						const reply = message?.reply;
						const type = message?.type;

						if (reply && timestamp !== this.transactionTS) {
							const payload = message?.payload;
							this.transactionTS = timestamp;
							const sumPaid = parseFloat(payload.sumPaid);

							switch (type) {
								case "message":
									this.alert = true
									this.alertDialog = payload
									break;
								case "update":
									console.log("Status update!");
									this.toPay = sumPaid
									this.writeLog(message);
									break;
								case "finished":
									console.log("Status finished!");

									this.toPay = sumPaid

									console.log(`Finished toPay: ${ this.countTotalPrice }, Paid: ${ this.toPay }`);
									// Record log to DB
									this.writeLog(message);

									if (this.toPay >= parseFloat(this.countTotalPrice)) {
										// Finish payment
										console.log("Payment finished!");
										// Zapisat do DB ze je OK
										this.updateOrderStatus(1, "cash");

										this.alert = false
										this.alertDialog = {
											title: 'payDialogPayCash',
											value: 'payDialogAccept' + ' ' + payDialogOrderNum + ' ' + this.paymentObject.oid,
											level: 'primary',
											button: false,
										}
										this.cashDialog = false
										this.paymentType = null

										// Tlac dokladu !!!
										// Ak tu s tym pracovat, tak load basketStore
										// basketStore.printReceipt(expId, order.value) - klasika
										// Android
										const print = {
											type: "print",
											response: this.paymentObject
										}

										const log = {
											type: 'log',
											payload: {
												orderId: this.paymentObject?.orderId,
												timestamp: Date.now(),
												print: print
											}
										}
										this.writeLog(log);

										this.printTransaction(print)
											.then((response) => {
												// self.router.push(`/${uid}/summary`)
											})
											.catch((err) => {
												// self.router.push(`/${uid}/summary`)
											})
										this.router.push(makePath('/summary'));
									}
									break;
								case "cancellation":
									console.log("Order canceled!");
									if (this.cashierFlag !== "cancel") {
										//resend API call
										console.log("Resend API cancel");
									} else {
										this.cashierFlag = null
									}
									// Zavriet cash Dialog
									this.paymentType = null
									this.cashDialog = false
									this.writeLog(message);
									break;
								case "start":
									// Check if response was sent
									if (this.cashierFlag !== "start") {
										//resend API call
										console.log("Resend API start");
									} else {
										this.cashierFlag = null
									}
									this.writeLog(message);
									break;
								case "print":
									if (this.cashierFlag !== "print") {
										//resend API call
										console.log("Resend API print");
										// posle POST /cashier => print

										const log = {
											type: 'log',
											payload: {
												orderId: this.paymentObject?.orderId,
												timestamp: Date.now(),
												print: "Resend API print"
											}
										}
										this.writeLog(log);
									} else {
										this.cashierFlag = null
									}
									this.writeLog(message);
									break;
								case "close":
									this.writeLog(message);
									break;
								case "pos":
									// Parse pos
									const posModel = useKioskStore().kiosk.posModel;
									const decodedData = payload;

									decodedData.message = b64DecodeUnicode(decodedData.message);
									// console.log(decodedData);
									switch (decodedData.state) {
										case "OK":
											// POS Opened
											console.log("POS OK");
											break;
										case "NOK":
											// POS Error
											console.log("POS NOK");
											break;
										case "RES":
											console.log("POS RES", JSON.stringify(decodedData || {}));
											const res = parseResponse(decodedData.message, posModel)
											console.log("POS data:", res);
											if (res === null) {
												break;
											}

											this.paymentStatus = {
												...res,
												posModel: posModel,
												lastId: this.paymentObject?.id || null
											}
											break;

										default:

											break;
									}

									break;
								default:
									break;
							}
						}
					}
				}))
				.catch((err) => {
					console.error("Error:getKioskStatus", err);
					this.alertDialog = {
						title: 'Start Transaction Status',
						value: err,
						level: 'negative',
						button: true
					}
				});
		},
		// startCashierStatus() {
		// 	if(interval !== null) {
		// 		clearInterval(interval)
		// 	}
		// 	// this.getKioskStatus();
		// 	interval = setInterval(() => {this.getKioskStatus()}, 1000);
		// },
		// stopCashierStatus() {
		// 	stopTimer(interval)
		// },
		writeLog(log) {
			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");

			const raw = JSON.stringify(log)

			// console.log("LOG ", raw);

			const requestOptions = {
				method: 'POST',
				headers: myHeaders,
				body: raw,
				redirect: 'follow'
			};

			fetch(`${ API_URL }/api/writelog`, requestOptions)
				.then((response) => response.text())
				.then((result) => {
					// console.log("New Log: ", JSON.parse(result));

				})
				.catch((error) => {
					console.log("Error:writeLog", error)
					// Chybovy Alert pre klienta !!!
					// kiosk.callAlert({
					// 	message: "Creating New Order error!!!"
					// })
				});
		},
		showAlert(code) {
			let title = '';
			let text = '';
			let alert = true;
			let lvl = 'negative';
			let btn = true;

			switch (code) {
				case 0:
					title = ''
					text = ''
					alert = false
					break;
				case 100:
					title = 'errorTitle100'
					text = 'errorValue100'
					break;
				case 200:
					title = 'errorTitle200'
					text = 'errorValue200'
					break;
				case 300:
					title = 'errorTitle300'
					text = 'errorValue300'
					lvl = 'warning'
					break;
				case 400:
					title = 'errorTitle400'
					text = 'errorValue400'
					break;
				case 500:
					title = 'errorTitle500'
					text = 'errorValue500'
					break;

				default:
					title = ''
					text = ''
					alert = false
					break;
			}

			this.alert = alert
			this.alertDialog = {
				title: title,
				value: text,
				level: lvl,
				button: btn
			}
		},
		// DEPRECATED:
		mPosPayment(pay) {
			axios.post(`${ API_URL }/ws/mpos/payment`, pay)
				.then((response) => {
					console.log("mPos Payment: ", response.data);
					// this.mPos.alert = true
				})
				.catch((error) => {
					console.log("Error:mPosPayment", error)
					this.alertDialog = {
						title: 'Payment Kiosk Status',
						value: error,
						level: 'negative',
						button: true
					}
				})
		},
		// DEPRECATED:
		mPosResponse(res) {
			// const ADMIN_URL = useKioskStore().ADMIN_URL;
			axios.post(`${ API_URL }/ws/mpos/response`, res)
				.then((response) => {
					console.log("mPOS Response: ", response.data);

				})
				.catch((error) => {
					console.log("Error:mPosResponse", error)
					this.alertDialog = {
						title: 'Payment Kiosk Status',
						value: error,
						level: 'negative',
						button: true
					}
				})
		},
		// DEPRECATED:
		startPos() {
			const { kioskId } = useNewKioskStore();
			// POST start
			console.log("startPOS START");
			const config = {
				headers: {
					'BSS-SENDER-ID': 'kiosk',
					'BSS-KIOSK-ID': kioskId,
					'Content-Type': 'application/json'
				}
			};

			// getParameter
			const kiosk = useKioskStore().kiosk;
			const pos = {
				type: "pos",
				response: {
					url: kiosk.posUrl,
					port: kiosk.posPort,
					command: { type: "open", value: "" }
				}
			}

			axios.post(`${ API_URL }/api/pos/open`, pos, config)
				.then((response) => {
					console.log("startPOS RESPONSE", response.data);
					const log = {
						type: 'log',
						payload: {
							orderId: this.paymentObject?.orderId,
							timestamp: Date.now(),
							pos: pos
						}
					}
					this.writeLog(log);
					// const res = response.data
				})
				.catch((error) => {
					console.log("Error:startPos", error)
					this.alertDialog = {
						title: 'Start Transaction Error',
						value: error,
						level: 'negative',
						button: true
					}
					this.alert = true;
				})
		},
		// DEPRECATED:
		closePos() {
			// POST close
			console.log("closePOS START");
			const config = {
				headers: {
					'BSS-SENDER-ID': 'kiosk',
					'BSS-KIOSK-ID': useKioskStore().uid,
					'Content-Type': 'application/json'
				}
			};

			// getParameter
			const kiosk = useKioskStore().kiosk;
			const pos = {
				type: "pos",
				response: {
					url: kiosk.posUrl,
					port: kiosk.posPort,
					command: { type: "close", value: "" }
				}
			}

			axios.post(`${ API_URL }/api/pos/close`, pos, config)
				.then((response) => {
					console.log("closePOS RESPONSE", response.data);
					// const res = response.data
				})
				.catch((error) => {
					console.log("Error:closePos", error)
					this.alertDialog = {
						title: 'Start Transaction Error',
						value: error,
						level: 'negative',
						button: true
					}
					this.alert = true;
				})
		},
		salePos(pay) {
			// POST sale
			const orderStore = useOrderStore();
			const { total, tipsAmount } = orderStore;
			const { kioskId } = useNewKioskStore();
			console.log("salePOS START", pay);
			const kiosk = useKioskStore().kiosk;
			const url = kiosk.posUrl;
			const port = kiosk.posPort;
			const model = kiosk.posModel;
			const protocol = kiosk.posProtocol;

			const config = {
				headers: {
					'BSS-SENDER-ID': 'kiosk',
					'BSS-KIOSK-ID': kioskId,
					'Content-Type': 'application/json'
				}
			};

			console.log('total:', total);
			console.log('tipsAmount:', tipsAmount);

			const tipsWithTotal = total + tipsAmount;

			console.log('tipsWithTotal:', tipsWithTotal);

			const raw = JSON.stringify({
				type: 'pos',
				...pay,
				uid: kioskId,
				url,
				port,
				model,
				protocol,
				total: tipsWithTotal
			});

			console.log('prepared data for pos/sale:', raw);

			axios.post(`${ API_URL }/api/pos/sale`, raw, config)
				.then((response) => {
					console.log("salePOS RESPONSE", response.data);
					// const res = response.data
				})
				.catch((error) => {
					console.log("Error:salePos", error)
					this.alertDialog = {
						title: 'Start Transaction Error',
						value: error,
						level: 'negative',
						button: true
					}
					this.alert = true;
				})
		},

	},
})
